module.exports = __webpack_public_path__ + "static/media/about_2_1.0847976c.png";